import styled from 'styled-components';

import Box from 'relements/build/esm/ui/box';
import Icon from 'relements/build/esm/ui/icon';
import Text from 'relements/build/esm/ui/text';
import Button from 'relements/build/esm/ui/button';

const ContainerStyle = (props) => ({
  flexDirection: 'column',
  width: '100%',
  background: props.theme.colors.yellow.pastel,
  transitionProperty: 'min-height, max-height, padding',
  transitionDuration: '0.2s, 0.2s, 0.2s',
  borderRadius: props.theme.radii.sm,
  padding: props.isExpanded ? '40px 16px 45px' : '18px 16px 14px',
  boxSizing: 'border-box',
  position: 'relative',
  '@media (max-width: 1150px)': {
    padding: props.isExpanded ? '40px 16px 50px' : '18px 16px 14px',
  },
});

export const Container = styled(Box)(ContainerStyle);

const IconStyle = (props) => ({
  height: `${props.height} !important`,
  width: `${props.width} !important`,
});
export const SvgIcon = styled(Icon)(IconStyle);

const IconBoxStyle = (props) => ({
  height: '40px',
  width: '40px',
  background: props.theme.colors.yellow.soft,
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: props.theme.space.zero,
  marginRight: 2 * props.theme.space.sm,
});
export const IconBox = styled(Box)(IconBoxStyle);

const TitleStyle = (props) => ({
  marginRight: props.theme.space.sm,
  lineHeight: '24px',
});
export const Title = styled(Text)(TitleStyle);

const DescriptionStyle = (props) => ({
  marginTop: 2 * props.theme.space.sm,
  lineHeight: '22px',
  color: props.theme.colors.black.haptik,
});
export const Description = styled(Text)(DescriptionStyle);

export const InputStyle = {
  fontSize: '16px',
  height: '42px',
};

const InputBoxStyle = (props) => ({
  marginTop: props.theme.space.md,
  padding: props.theme.space.zero,
  flexWrap: 'wrap',
});
export const InputBox = styled(Box)(InputBoxStyle);

const InviteButtonStyle = (props) => ({
  height: '42px',
  width: '30%',
  margin: props.theme.space.zero,
  marginLeft: 2 * props.theme.space.sm,
  fontSize: '16px',
  transition: 'margin 300ms',
  '@media (max-width: 1150px)': {
    width: '100%',
    marginLeft: props.theme.space.zero,
    marginTop: 2 * props.theme.space.sm,
  },
});
export const InviteButton = styled(Button)(InviteButtonStyle);

const MessageBoxStyle = {
  padding: '0',
  alignItems: 'center',
  position: 'absolute',
  bottom: '0',
  height: '45px',
  '@media (max-width: 1150px)': {
    height: '80px',
    bottom: '-20px',
    background: 'none',
  },
};
export const MessageBox = styled(Box)(MessageBoxStyle);

const MessageStyle = (props) => ({
  flex: 1,
  marginLeft: 6,
  lineHeight: '17px',
  color: props.isSuccess
    ? props.theme.colors.green.haptik
    : props.theme.colors.red.haptik,
  a: {
    color: props.theme.colors.red.haptik,
    textDecoration: 'none',
    borderBottom: `1px solid ${props.theme.colors.red.haptik}`,
  },
});
export const Message = styled(Text)(MessageStyle);

const MessageIconBoxStyle = (props) => ({
  height: '18px',
  width: '18px',
  background: props.isSuccess
    ? props.theme.colors.green.haptik
    : props.theme.colors.red.haptik,
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: props.theme.space.zero,
});
export const MessageIconBox = styled(Box)(MessageIconBoxStyle);
